import { type DashRouteType, URL_PARTNER_SCOPED } from '@retailer-platform/dashboard/routing'

const URL_SEARCH_PLATFORM = `${URL_PARTNER_SCOPED}/search-platform`
const URL_SEARCH_PLATFORM_SEARCH_RESULTS = `${URL_SEARCH_PLATFORM}/search-results`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'search-platform'>
  | DashRouteType<'search-platform-search-results'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'search-platform': URL_SEARCH_PLATFORM,
  'search-platform-search-results': URL_SEARCH_PLATFORM_SEARCH_RESULTS,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
